import React from 'react';
import { withTranslation } from 'react-i18next';
import { db } from '../../config/firebase';
import {
    Checkbox,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Snackbar,
    Popper,
    MenuList,
    Grow,
    Paper,
    ClickAwayListener,
    adaptV4Theme,
} from '@mui/material';
import { ExpandMoreOutlined, DeleteForeverOutlined,EditOutlined } from '@mui/icons-material';
import { createTheme, ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import { DeleteDialog, ChildDialog } from './index';
import boyImg from '../../assets/images/boy.png';
import girlImg from '../../assets/images/girl.png';

const muiTheme = createTheme(adaptV4Theme({
    overrides: {
        MuiMenu: {
            list: {
                overflowX:'auto'
            },
        },
    }
}));

const StyleCheckbox = withStyles({
    root: {
      color: '#0F467A',
      '&$checked': {
        color: '#0F467A',
      },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const styles = theme => ({
    mainDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        width:'250px',
        borderRadius:'8px',
        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2)',
        height:'65px',
        padding:'10px',
        cursor:'pointer',
        marginTop:'10px',
    },

    kidInfo:{
        display:'flex',
        flexDirection:'row',
        width: 'calc(250px - 42px)',
        "& img":{
            width:'60px',
            height:'60px',
            borderRadius:'50px',
        }
    },

    kidInDiv:{
        display:'flex',
        flexDirection:'column',
        marginLeft:'10px',
        width:'calc(100% - 60px)'
    },

    kidName:{
        width: 'calc(100% - 6%)',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        fontWeight:'bold',
        textTransform:'capitalize'
    },

    kidAge:{
        width: 'calc(100% - 6%)',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        fontSize:'13px',
        color:'rgba(0, 0, 0, 0.54)'
    },

    formDiv:{
        position:'absolute',
        top:'111%',
        backgroundColor:'#e1ebf5',
        boxShadow: 'rgba(50, 50, 93, 0.14902) 0px 12px 10px, rgba(0, 0, 0, 0.0196078) 0px 3px 5px',
        width:'calc(100% - 20px)',
        borderRadius:"8px",
        padding:'10px',
        zIndex:100,
        flexDirection:'column',
        "&::before":{
            display: 'block',
            position: 'absolute',
            top: '-7px',
            left: '28px',
            border: '8px solid #e1ebf5',
            borderColor: 'transparent transparent #e1ebf5 #e1ebf5',
            transform: 'translateX(-50%) rotate(135deg)',
            boxShadow: '-2px 2px 3px rgba(57,73,76,.1)',
            content: "close-quote",
        },
    },

    priceDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between',
        marginTop:'10px'
    },

    saveBtn: {
        whiteSpace: 'nowrap',
        border: 0,
        outline: 0,
        display: 'inline-block',
        height: '40px',
        lineHeight: '40px',
        fontFamily: "'Poppins', sans-serif",
        padding: '0 14px',
        boxShadow: '0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)',
        color: '#fff',
        borderRadius: '4px',
        fontSize: '15px',
        fontWeight: '600',
        textTransform: 'uppercase',
        letterSpacing: '0.025em',
        backgroundColor: '#0F467A',
        textDecoration: 'none',
        '-webkitTransition': 'all 150ms ease',
        transition: 'all 150ms ease',
        alignSelf: 'flex-end',
        '&:hover': {
            color: '#fff',
            cursor: 'pointer',
            transform: 'translateY(-1px)',
            boxShadow: '0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08)'
        },
    },

    priceSpan:{
        color: '#6b7c93',
        letterSpacing: '0.025em',
        fontWeight:'bold',
        fontFamily: "'Poppins', sans-serif"
    },

    selectInput:{
        marginTop:'15px',
        display: 'block',
        padding: '10px 14px',
        fontFamily: "'Cairo', sans-serif",
        fontSize: '1em',
        border: 0,
        outline: 0,
        borderRadius: '4px',
        backgroundColor: '#F4F6F8',
        border:'1px solid #E5E5E5',
        [theme.breakpoints.between('xs','md')]: {
            padding: '10px 5px',
		}
    },

    root: {
        padding:'0px',
        width:'100%',
        '& .MuiInputBase-root': {
            width: '100%',
        },
        '& .MuiOutlinedInput-input':{
            padding:'10.5px 14px'
        },
        '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
              borderColor: '#0F467A',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#0F467A',
            },
          },
    },

    label:{
        color:'#000 !important',
        lineHeight:0
    },

    labelFocused:{
        color:'#0F467A !important'
    },

    menuItem:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center'
    },

    menuItem2:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between',
        flexWrap:'wrap'
    },

    activityImg:{
        width: "45px",
        height: "25px",
        minWidth: "45px",
        minHeight: "25px",
    },

    gpName:{
        marginRight: '45px',
        textOverflow: 'ellipsis',
        fontFamily: "'Cairo', sans-serif",
        [theme.breakpoints.between('xs','md')]: {
        marginRight:'0px'
		}
    },

    editMenu:{
        position: 'absolute',
        right:0,
        top: '10px',
        fontSize: '22px',
        '& svg':{
            fontSize:'26px',
            color:'rgba(0,0,0,0.3)'
        }
    },

    positionLeft:{
        left:'0px !important',
        right:'inherit !important'
    },

    editMenuItem:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
    },

    menuIconRight:{
        marginRight:'8px'
    },

    menuIconLeft:{
        marginLeft:'8px'
    },

    MuiMenuRoot:{
        whiteSpace:'pre-line',
        wordBreak:'break-word'
    },

    activityName:{
        fontFamily:"'Cairo', sans-serif",
        marginLeft:'5px',
    }
})

class ChildCard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            open:false,
            deleteDialog:false,
            childForm:false,
            message:'',
            snackOpen:false,
            kidId:''
        }
        this.anchorRef = React.createRef();
    }

    activityChange = e => {
        const { index } = this.props;
        this.props.onChangeActivity(e,index)
    }

    groupChange = e => {
        const { index } = this.props;
        this.props.onChangeGroup(e,index)
    }

    saveClick = () => {
        const { index } = this.props;
        this.props.saveEvent(index)
    }

    _cardClick = () => {
        const {currentKid,dataAvailable} = this.props;
        if(!dataAvailable) this.props.onCardClick(currentKid.kidId);
    }

    _checkboxEvent = () => {
        const { index,currentKid } = this.props;
        this.props.checkboxEvent(index,currentKid.kidId);
    }

    _checkboxClick = e => {
        const {selected} = this.props;
        if(selected) {
            e.stopPropagation()
        }
    }
    
    // menu list
    openToggle = () => {
        const { open } = this.state;
        this.setState({open: !open})
    }

    handleClose = () => this.setState({open:false})

    handleListKeyDown = (event) => {
        if (event.key === 'Tab') {
          event.preventDefault();
            this.setState({open:false})
        }
    }

    // delete dialog
    closeDeleteDialog = () => this.setState({deleteDialog:false})

    openDeleteDialog = () => this.setState({deleteDialog:true},() => this.handleClose())

    // delete kid
    deleteKid = () => {
        const { currentKid,getKidEvent,userCurrencyEvent } = this.props;
        if(currentKid.kidId) {
            db.ref(`Kids/${currentKid.kidId}`).remove()
            .then(() => this.setState({message:'Kid remove successfully',snackOpen:true},()=> {
                this.closeDeleteDialog();
                setTimeout(async ()=> {
                    await userCurrencyEvent();
                    await getKidEvent();
                },1000)
            }))
            .catch(e => this.setState({message:e.message,snackOpen:true}))
        }
    }

    // edit Dialog
    ChildDialogClose = () => this.setState({childForm:false})

    openChildDialog = () => {
        const { currentKid } = this.props;
        if(currentKid.kidId) {
            this.setState({kidId:currentKid.kidId,childForm:true},() => this.handleClose())
        }
    }
    // after kid successfully update
    onUpdateChild = () => {
        const { getKidEvent, userCurrencyEvent } = this.props;
        this.setState({message:'Kid update successfully',snackOpen:true},()=> setTimeout(async ()=> {
            await userCurrencyEvent()
            await getKidEvent();
        },1000))
    }

    // snackbar
    snackClose = () => this.setState({snackOpen:false})

    render() {
        const { open,  deleteDialog, message, snackOpen, childForm, kidId } = this.state;
        const { classes, gender,selectedCard, cardRef,selected,groups,activities,activityId,groupId,currentKid,isParent,i18n,t } = this.props;
        const isRTL = i18n.translator.language;
        const ar = "'Cairo', sans-serif";
        const en = "'Poppins', sans-serif";
        const fontFamily = isRTL === 'ar' ? ar : en;
        const menuList = [{ icon:<EditOutlined className={isRTL === 'ar' ? classes.menuIconLeft : classes.menuIconRight}/>, label:t('setting-comp.edit'),clickEvent:this.openChildDialog },
        // { icon:<DeleteForeverOutlined className={isRTL === 'ar' ? classes.menuIconLeft : classes.menuIconRight}/>, label:t('duplicate.delete'),clickEvent:this.openDeleteDialog }
        ];
        let genderImg = gender.toLowerCase() === 'girl' ? girlImg : boyImg;
        let isActive = currentKid.kidId === selectedCard;
    return (
        (<div style={{position:'relative'}}>
            <div className={classes.mainDiv} ref={cardRef} onClick={this._cardClick} style={{border: isActive ? '2px solid #0F467A' : '1px solid #e4e8ed',width: isActive ? '250px' : '260px'}}>
                <div className={`${classes.editMenu} ${isRTL === 'ar' ? classes.positionLeft : undefined}`} style={{display:isParent ? 'none' : 'flex'}}>
                    <ExpandMoreOutlined onClick={this.openToggle} ref={this.anchorRef}/>
                    <Popper open={open} style={{zIndex:101}} anchorEl={this.anchorRef.current} role={undefined} transition disablePortal>
                    {({ TransitionProps, placement }) => (
                        <Grow
                        {...TransitionProps}
                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                        >
                        <Paper>
                            <ClickAwayListener onClickAway={this.handleClose}>
                            <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={this.handleListKeyDown}>
                                {menuList.map(v => <MenuItem key={v.label} className={classes.editMenuItem} onClick={v.clickEvent}>{v.icon} <span style={{fontFamily}}>{v.label}</span></MenuItem> )}
                            </MenuList>
                            </ClickAwayListener>
                        </Paper>
                        </Grow>
                    )}
                    </Popper>
                </div>
                <StyleCheckbox checked={selected} onChange={this._checkboxEvent} onClick={this._checkboxClick} name="checkedG" />
                <div className={classes.kidInfo}>
                    <img src={currentKid.avatar ? currentKid.avatar : genderImg} alt="kid-img" />
                    <div className={classes.kidInDiv} style={isRTL === 'ar' ? {marginRight:'10px'} : {marginLeft:'10px'}}>
                        <span className={classes.kidName} style={{fontFamily}}>{currentKid.kidName ?? '---'}</span>
                        <span className={classes.kidAge} style={{fontFamily}}>{t('reservation.kid-birth', {count: Math.floor(((new Date()).getTime() - (currentKid.birthdate*1000)) / (1000 * 60 * 60 * 24 * 365)) })}</span>
                    </div>
                </div>
            </div>
            <div className={classes.formDiv} style={{display:isActive ? 'flex' : 'none'}}>
                <FormControl variant="outlined" className={classes.selectInput} classes={{root:classes.root}}>
                    <InputLabel classes={{root:classes.label,focused:classes.labelFocused}}>{t('duplicate.select-ac')}</InputLabel>
                    <Select
                        variant="standard"
                        defaultValue=""
                        value={activityId}
                        onChange={this.activityChange}
                        label="Select Activity"
                        inputProps={{style:{ padding: '10.5px 14px' }}}>
                        <MenuItem value="" style={{fontFamily}}>{t('duplicate.select-ac')}</MenuItem>
                        {activities.length > 0 && activities.map(v=> {
                            return(
                                <MenuItem className={classes.menuItem} key={v.id} value={v.id}>
                                    <img alt="serviceImg" src={v.cover} className={classes.activityImg}/>
                                    <span className={classes.activityName} style={{fontFamily}}>{v.name}</span>
                                </MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
                <FormControl variant="outlined" className={classes.selectInput} classes={{root:classes.root}}>
                    <InputLabel classes={{root:classes.label,focused:classes.labelFocused}}>{t('change-group.select group')}</InputLabel>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={muiTheme}>
                            <Select
                                variant="standard"
                                defaultValue=""
                                value={groupId}
                                onChange={this.groupChange}
                                label="Select Group"
                                inputProps={{style:{ padding: '10.5px 14px' }}}>
                                <MenuItem value="" style={{fontFamily}}>{t('change-group.select group')}</MenuItem>
                                {groups.length > 0 && groups.map(v=>  {
                                    return(
                                        <MenuItem classes={{root:classes.MuiMenuRoot}} className={classes.menuItem2} key={v.id} value={v.id}>
                                            <span className={classes.gpName} style={{fontFamily}}>
                                                {v.name}
                                            </span>
                                            <span><b>{`${v.price} ${v.currency}`}</b></span>
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </ThemeProvider>
                    </StyledEngineProvider>
                </FormControl>
                <div className={classes.priceDiv}>
                    {currentKid.currency ? <span className={classes.priceSpan} style={{fontFamily}}><span style={{color:"#0F467A"}}> {t('group-list.gp-price')}: </span> {`${currentKid.groupPrice} ${currentKid.currency}`}</span> : <span></span>}
                    <button className={classes.saveBtn} style={{fontFamily}} onClick={this.saveClick}>{t('comp-comp.save')}</button>
                </div>
            </div>
            <DeleteDialog 
                open={deleteDialog}
                onClose={this.closeDeleteDialog}
                handleSubmit={this.deleteKid}
                t={t}
                isRTL={isRTL}
            />
            <ChildDialog 
                open={childForm}
                kidId={kidId}
                onClose={this.ChildDialogClose}
                onSaveChild={this.onUpdateChild}
                t={t}
                isRTL={isRTL}
            />
            <Snackbar
                anchorOrigin={{ vertical:'bottom', horizontal:'center' }}
                key='bottom center'
                open={snackOpen}
                autoHideDuration={3000}
                onClose={this.snackClose}
                ContentProps={{
                'aria-describedby': 'message-id',
                }}
                message={<span id="message-id">{message}</span>}
            />
        </div>)
    );}
}

export default withStyles(styles)(withTranslation('common')(ChildCard));